import React, {FunctionComponent} from "react";
import {Layout} from "antd";

export const Sider: FunctionComponent = ({children}) => (
  <Layout.Sider theme="light" width={440}>
    {children}
  </Layout.Sider>
);
